module.exports = __webpack_public_path__ + "static/media/sampleSKU.f40fb8f6.png";